import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import * as Styled from "./functioning.styles";
import Image from "next/image";

interface FunctioningCardProps {
  title: string;
  idx: number;
  selecteditem?: number;
}

export const FunctioningCard: FC<FunctioningCardProps> = ({
  title,
  idx,
  selecteditem,
}) => {
  const { t } = useTranslation("global");
  const controls = useAnimation();

  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const variants = {
    hidden: { opacity: 0 },

    visible: ({ delay }: { delay: number }) => ({
      opacity: 1,
      transition: {
        delay,
        duration: 1,
      },
    }),
  };

  return (
    <motion.div
      ref={ref}
      custom={{ delay: (idx + 1) * 0.3 }}
      initial="hidden"
      animate={controls}
      exit="hidden"
      variants={variants}
      layoutId={title}
    >
      <Styled.CardContainer>
        <Styled.ImgBox>
          <Styled.CustomImg>
            <Image
              src={`./assets/functioning/functioningSvg/${title}.svg`}
              alt="card-img"
              fill
            />
          </Styled.CustomImg>
        </Styled.ImgBox>
        <Styled.CardTitle
          className="headline-medium weight-medium"
          selecteditem={selecteditem}
        >
          {t(`functioning.cards.${title}.title`)}
        </Styled.CardTitle>
        <Styled.CardDescription
          className="body-medium"
          selecteditem={selecteditem}
        >
          {t(`functioning.cards.${title}.description`)}
        </Styled.CardDescription>
      </Styled.CardContainer>
    </motion.div>
  );
};
